"use client";
import StatusChecker from "./StatusChecker";

export default function StatusCheckerWrapper() {
  return <StatusChecker />;
}